import type { ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './MarketingCta.module.css';

interface PrimaryCTAProps {
  className?: string;
  href: string;
  icon?: ReactNode;
  label: string;
}

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ');
}

export function PrimaryCTA({
  className,
  href,
  icon,
  label,
}: PrimaryCTAProps) {
  return (
    <Link className={classNames(styles.cta, styles.primary, className)} to={href}>
      <span>{label}</span>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
    </Link>
  );
}
